import { Link, useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

const categoryNames: Record<string, string> = {
  dianshi: '电视剧',
  dianying: '电影',
  zongyi: '综艺',
  dongman: '动漫',
  jilupian: '纪录片',
  duanju: '短剧',
  tiyu: '体育',
  yinyue: '音乐',
};

export default function Breadcrumb() {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);

  const items: BreadcrumbItem[] = [{ label: '首页', path: '/' }];

  if (pathSegments[0] === 'category' && pathSegments[1]) {
    items.push({ label: categoryNames[pathSegments[1]] || pathSegments[1] });
  } else if (pathSegments[0] === 'article' && pathSegments[1]) {
    items.push({ label: '文章详情' });
  } else if (pathSegments[0] === 'about') {
    items.push({ label: '关于我们' });
  }

  const schemaData = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.label,
      item: item.path ? `https://www.91tv.com${item.path}` : undefined,
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
      <nav aria-label="面包屑导航" className="flex items-center gap-1.5 text-sm text-foreground-500 py-3">
        {items.map((item, idx) => (
          <span key={idx} className="flex items-center gap-1.5">
            {idx > 0 && <i className="ri-arrow-right-s-line text-xs text-foreground-400"></i>}
            {item.path ? (
              <Link to={item.path} className="hover:text-primary-500 transition-colors cursor-pointer">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-700">{item.label}</span>
            )}
          </span>
        ))}
      </nav>
    </>
  );
}